import { useDispatch } from 'react-redux';
import FJModal from '../FJModal';
import FJUpgradesTips from './FJUpgradesTips';
import { useSelector } from 'react-redux';
import { setSliceUpgradeTipsModalData } from '../../../redux/slices/FJSliceModals';
import FJActionCommon from '../../../redux/action/FJActionCommon';

const FJUpgradesTipsContainer = () => {
    const dispatch = useDispatch();

    const upgradeTipsModalData = useSelector(state => state.modals.upgradeTipsModalData);

    const { display, data = {} } = upgradeTipsModalData;

    const {
        title = 'purchase-credits-for-bulk-removal',
        content = 'free-trial-does-not-support-bulk-removal-please-purchase-credits-and-access-to-the-bulk-removal-up-to-20-images-at-once',
        buttonText = 'get-credits',
        buttonType,
        callback = () => {},
    } = data;

    const handleClose = () => {
        dispatch(setSliceUpgradeTipsModalData({ display: false }));
        callback();
    };

    const onUpgrade = () => {
        handleClose();
        dispatch(FJActionCommon.getCreditsAction());
    };

    const onClick = () => {
        handleClose();
    };

    return (
        <FJModal visible={display}>
            <FJUpgradesTips
                title={title}
                content={content}
                buttonText={buttonText}
                onClose={handleClose}
                onUpgrade={onUpgrade}
                buttonType={buttonType}
                onClick={onClick}
            />
        </FJModal>
    );
};

export default FJUpgradesTipsContainer;
